import { classNames } from '@src/utils/classNames';

export type ErrorMessageForFieldProps = {
  showErrorMessage?: boolean;
  errorMessage: string | null;
  errorClassName?: string;
};

export function ErrorMessageForField({
  showErrorMessage = true,
  errorMessage,
  errorClassName,
}: ErrorMessageForFieldProps) {
  return (
    <span
      data-testid="validation-error"
      className={classNames(
        'block text-label-input-text text-orange-600 opacity-0 transition-opacity text-sm relative w-full',
        showErrorMessage && 'opacity-100',
        errorClassName,
      )}
    >
      {/* This zero-width-space prevents the height from collapsing if there is no error message */}
      &#8203;
      {showErrorMessage && errorMessage && (
        <span className="max-w-full" data-testid="validation-error-message">
          {errorMessage}
        </span>
      )}
    </span>
  );
}
